function getDefaultImage(images) {
  if (!Array.isArray(images) || images.length === 0) return null
  return images.find(image => (image.isDefault ?? image.IsDefault) === true) || images[0] || null
}

export function mapResolvedProduct(product, productTypes, brands, categories) {
  const normalizedProduct = {
    id: product.id ?? product.Id ?? null,
    articul: product.articul ?? product.Articul ?? '',

    basePrice: product.basePrice ?? product.BasePrice ?? 0,
    salePrice: product.salePrice ?? product.SalePrice ?? null,

    basePriceKzt: product.basePriceKzt ?? product.BasePriceKzt ?? null,
    salePriceKzt: product.salePriceKzt ?? product.SalePriceKzt ?? null,
    rateUsed: product.rateUsed ?? product.RateUsed ?? null,

    saleIsActive: product.saleIsActive ?? product.SaleIsActive ?? false,
    quantity: product.quantity ?? product.Quantity ?? 0,
    productTypeId: product.productTypeId ?? product.ProductTypeId ?? null,
    isDefault: product.isDefault ?? product.IsDefault ?? false,
    images: (product.images ?? product.Images ?? []).map(image => ({
      id: image.id ?? image.Id ?? null,
      url: image.url ?? image.Url ?? '',
      storageKey: image.storageKey ?? image.StorageKey ?? null,
      isDefault: image.isDefault ?? image.IsDefault ?? false
    })),
    characteristicValues: (product.characteristicValues ?? product.CharacteristicValues ?? []).map(item => ({
      characteristicId:
        item.characteristicId ??
        item.CharacteristicId ??
        item.attributeId ??
        item.AttributeId ??
        null,
      valueId:
        item.valueId ??
        item.ValueId ??
        item.characteristicValueId ??
        item.CharacteristicValueId ??
        null
    })).filter(item => item.valueId != null)
  }

  const productType =
    productTypes.find(pt => (pt.id ?? pt.Id) === normalizedProduct.productTypeId) || null

  const brand = productType
    ? brands.find(b => (b.id ?? b.Id) === (productType.brandId ?? productType.BrandId)) || null
    : null

  const category = productType
    ? categories.find(c => (c.id ?? c.Id) === (productType.categoryId ?? productType.CategoryId)) || null
    : null

  const defaultImage = getDefaultImage(normalizedProduct.images)

  const selectedValueIds = new Set(
    normalizedProduct.characteristicValues.map(item => Number(item.valueId))
  )
  const selectedByAttributeId = new Map(
    normalizedProduct.characteristicValues
      .filter(item => item.characteristicId != null)
      .map(item => [Number(item.characteristicId), Number(item.valueId)])
  )

  const productAttributes = product.attributes ?? product.Attributes ?? []
  const typeAttributes = productType?.attributes ?? productType?.Attributes ?? []
  const attributeSource = productAttributes.length ? productAttributes : typeAttributes

  const attributes = attributeSource.map(attr => {
    const attrId = attr.id ?? attr.Id ?? null
    const values = (attr.values ?? attr.Values ?? []).map(value => ({
      id: value.id ?? value.Id ?? null,
      value: value.value ?? value.Value ?? '',
      attributeName: value.attributeName ?? value.AttributeName ?? attr.name ?? attr.Name ?? ''
    }))
    let selectedId = attr.selectedValueId ?? attr.SelectedValueId ?? null

    if (selectedId == null && attrId != null) {
      selectedId = selectedByAttributeId.get(Number(attrId)) ?? null
    }

    if (selectedId == null) {
      selectedId = values.find(value => selectedValueIds.has(Number(value.id)))?.id ?? null
    }

    const selected = values.find(v => Number(v.id ?? v.Id) === Number(selectedId))

    return {
      id: attr.id ?? attr.Id ?? null,
      name: attr.name ?? attr.Name ?? '',
      values,
      selectedValueId: selectedId,
      selectedValue: selected ? (selected.value ?? selected.Value) : 'Не выбрано'
    }
  })

  return {
    id: normalizedProduct.id,
    articul: normalizedProduct.articul,

    basePrice: normalizedProduct.basePrice,
    salePrice: normalizedProduct.salePrice,

    basePriceKzt: normalizedProduct.basePriceKzt,
    salePriceKzt: normalizedProduct.salePriceKzt,
    rateUsed: normalizedProduct.rateUsed,

    saleIsActive: normalizedProduct.saleIsActive,
    quantity: normalizedProduct.quantity,
    productTypeId: normalizedProduct.productTypeId,
    isDefault: normalizedProduct.isDefault,
    characteristicValues: normalizedProduct.characteristicValues,
    images: normalizedProduct.images,
    defaultImageUrl: defaultImage?.url ?? null,

    name: productType?.name ?? productType?.Name ?? 'Без названия',
    description: productType?.description ?? productType?.Description ?? '',
    productType,

    brandId: productType?.brandId ?? productType?.BrandId ?? null,
    brandName: brand?.name ?? brand?.Name ?? 'Без бренда',

    categoryId: productType?.categoryId ?? productType?.CategoryId ?? null,
    categoryName: category?.name ?? category?.Name ?? 'Без категории',

    isActive: productType?.isActive ?? productType?.IsActive ?? false,
    attributes
  }
}

export function mapResolvedProducts(products, productTypes, brands, categories) {
  return products.map(product =>
    mapResolvedProduct(product, productTypes, brands, categories)
  )
}
